import React, { FC, useEffect, useState } from "react";
import {
  Container,
  Form,
  Input,
  TextArea,
  Heading,
  Description,
  SubmitButton,
} from "./styles";
import { useForm } from "react-hook-form";

interface Props {
  className?: string;
  heading?: string;
  description?: string;
  position: string;
}

interface FormInputs {
  fullName: string;
  email: string;
  phone: string;
  resumeUrl: string;
  coverLetter: string;
  positionTitle: string;
}

const PositionForm: FC<Props> = ({
  heading,
  description,
  className,
  position,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormInputs>();
  const [sent, setSent] = useState<boolean>(false);

  // Transforms the form data from the React Hook Form output to a format Netlify can read
  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  };

  const onSubmit = async (formData, event) => {
    if (sent) return;

    const response = await fetch(`/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": event.target.getAttribute("name"),
        ...formData,
      }),
    });

    if (!response.ok) return;

    setSent(true);
  };

  return (
    <Container className={className}>
      {heading && <Heading>{heading}</Heading>}
      {description && <Description>{description}</Description>}
      <Form
        name="position-form"
        method="POST"
        onSubmit={handleSubmit(onSubmit)}
        data-netlify="true"
      >
        <input type="hidden" name="form-name" value="position-form" />
        <input type="hidden" {...register("positionTitle")} value={position} />
        <Input
          placeholder="Your full name please *"
          {...register("fullName", {
            required: true,
          })}
          error={!!errors.fullName}
        />
        <Input
          placeholder="Email address *"
          type="email"
          {...register("email", {
            required: true,
          })}
          error={!!errors.email}
        />
        <Input
          placeholder="Phone number *"
          type="tel"
          {...register("phone", {
            required: true,
          })}
          error={!!errors.phone}
        />
        <Input
          placeholder="Resume URL s*"
          {...register("resumeUrl", {
            required: true,
          })}
          error={!!errors.resumeUrl}
        />
        <TextArea
          placeholder="Cover letter *"
          {...register("coverLetter", {
            required: true,
          })}
          rows={1}
          error={!!errors.coverLetter}
        />
        <SubmitButton type="submit" small={true} sent={sent}>
          {sent ? "Done!" : "Apply for position"}
        </SubmitButton>
      </Form>
    </Container>
  );
};

export default PositionForm;
